import { format } from 'date-fns';
import apiService from '../../Services/APIService';
import { checkAPIResponse } from '../../Utils/APIResponseUtils';
import { capitaliseString, combineDateTime } from '../../Utils/Utilities';
import { getFromIndexedDB } from '../../Utils/IndexedDBUtils';

// Unified function to handle add, update, and delete thread operations
export const manageRecordAPI = async (recordData, taskData = null, operation = 'ADD', recChangeTypeID = 0) => {
  // recChangeTypeID 
  // 0 -> record entry
  // 1 -> record entry with next task
  // 2 -> record entry after task done
  // 5 -> delete record

  const changeTypeMap = {
    0: "REC",
    1: "RECTASK",
    2: "RECEDIT",
    3: "RECSTG",
    4: "RECTASKSTG",
    5: "RECDEL"
  };

  let dueDTVal = '';
  if (taskData && taskData.dueDT) {
    let dateStr = taskData.dueDT;
    let [onlyDate, onlyTime] = dateStr.split(" ");
    const parts = onlyDate.split("-");
    if (parts.length === 3 && parts[2].length === 2 && isNaN(Number(parts[1]))) {
      parts[2] = "20" + parts[2];
      onlyDate = parts.join("-");
    }
    dateStr = onlyDate + (onlyTime ? " " + onlyTime : "");

    let combinedStr = dateStr;
    const finalTime = taskData.dueTime || onlyTime;
    if (finalTime && !onlyDate.includes(":")) {
      combinedStr = onlyDate + " " + finalTime;
    }
    let parsed = new Date(combinedStr);
    if (isNaN(parsed.getTime())) {
      parsed = new Date(combinedStr.replace(" ", "T"));
    }
    if (!isNaN(parsed.getTime())) {
      dueDTVal = format(parsed, 'dd-MMM-yy hh:mm a');
    }
  }

  let recPayloadData = {
    changeType: '',
    connID: 0,
    pocUserID: 0,
    recID: 0,
    taskName: taskData?.taskName || '',
    description: taskData?.description || '',
    taskID: taskData?.taskID || 0,
    priority: taskData?.priority || '',
    status: taskData?.status || 1,
    taskType: taskData?.taskType ? capitaliseString(taskData.taskType) : '',
    taskThreadIDs: taskData?.threads ? (Array.isArray(taskData.threads) ? taskData.threads.join(',') : taskData.threads) : '',
    taskContractIDs: taskData?.contracts ? (Array.isArray(taskData.contracts) ? taskData.contracts.join(',') : taskData.contracts) : '',
    dueDT: dueDTVal,
    recDT: recordData?.recDT ? (recordData.recDT instanceof Date ? format(recordData.recDT, 'dd-MMM-yy hh:mm a') : format(new Date(recordData.recDT), 'dd-MMM-yy hh:mm a')) : format(new Date(), 'dd-MMM-yy hh:mm a'),
    recUID: recordData?.pocUserID,
    recType: recordData?.recType ? capitaliseString(recordData.recType) : '',
    recNotes: recordData?.recNotes || '',
    recLat: recordData?.recLat || '',
    recLon: recordData?.recLon || '',
    recThreadIDs: recordData?.recThreadIDs || '',
    contacts: '[]',
    recContractIDs: recordData?.recContractIDs || '',
    currStageID: recordData?.currStageID ? recordData.currStageID : recChangeTypeID === 5 ? -3 : 1,
    reason: recordData?.reason || '',
    recSecConnIDs: recordData?.recSecConnIDs || '',
    nextTaskSecConnIDs: taskData?.secConnIDs ? (Array.isArray(taskData.secConnIDs) ? taskData.secConnIDs.join(',') : taskData.secConnIDs) : '',
    isCold: recordData?.isMarkCold ? 1 : 0,
    rmdrDT: taskData?.rmdrDT ? (taskData.rmdrDT instanceof Date ? format(taskData.rmdrDT, 'dd-MMM-yy hh:mm a') : taskData.rmdrDT) : '',
    isRmdrUpdate: taskData?.isRemind !== undefined ? "1" : "0",
    usrCtgCID: taskData?.myCategory || 0,
  }
  
  if (recChangeTypeID === 2) {
    recPayloadData.changeType = changeTypeMap[recChangeTypeID];
    recPayloadData.connID = recordData.connID || 0;
    recPayloadData.pocUserID = recordData.pocUserID;
    recPayloadData.recID = recordData.recID || 0;
  }
  else if ([0, 1, 3, 4].includes(recChangeTypeID)) {
    recPayloadData.changeType = changeTypeMap[recChangeTypeID];
    recPayloadData.connID = recordData.connID || 0;
    recPayloadData.pocUserID = recordData.pocUserID;
    recPayloadData.recID = 0;

    if (recChangeTypeID === 3) {
      if (recPayloadData.currStageID === -1) {
        recPayloadData.changeType += 'CNCL';
        recPayloadData.currStageID = 1;
      } 
      else if (recPayloadData.currStageID === -2) {
        recPayloadData.changeType += 'DONE';
        recPayloadData.currStageID = 1;
      }
      else if (recPayloadData.currStageID === -3) {
        recPayloadData.changeType += 'DONE';
        recPayloadData.currStageID = 1;
        recPayloadData.reason = recPayloadData.reason || 'Converted to Sale';
      }
    }
  } else if (recChangeTypeID === 5 && !taskData) {
    recPayloadData.changeType = changeTypeMap[recChangeTypeID];
    recPayloadData.connID = recordData.connID || 0;
    recPayloadData.pocUserID = recordData.pocUserID;
    recPayloadData.recID = recordData.recID || 0;
  } else if ((recChangeTypeID == 5) && taskData) {
    recPayloadData.changeType = 'RECTSKCMP';
    recPayloadData.recID = 0;
      if (recPayloadData.currStageID === -1) {
        recPayloadData.changeType += 'CNCL';
        recPayloadData.currStageID = 1;
      } 
      else if (recPayloadData.currStageID === -2) {
        recPayloadData.changeType += 'DONE';
        recPayloadData.currStageID = 1;
        recPayloadData.taskThreadIDs = recPayloadData.recThreadIDs;
      }
      else if (recPayloadData.currStageID === -3) {
        recPayloadData.changeType += 'DONE';
        recPayloadData.currStageID = 1;
        recPayloadData.taskThreadIDs = recPayloadData.recThreadIDs;
        recPayloadData.reason = recPayloadData.reason || 'Converted to Sale';
      } else if (recChangeTypeID == 5) {
        recPayloadData.changeType = "RECTSKCMPSTGMV";
        recPayloadData.taskThreadIDs = recPayloadData.recThreadIDs
      }
    recPayloadData.connID = taskData.connID || 0;
    recPayloadData.pocUserID = taskData.pocUserID || 0;
  }

  const connID = recordData?.connID || taskData?.connID || 0;
  let apiOptions = {};
  if (connID) {
    try {
      const conns = await getFromIndexedDB('Conns') || [];
      const connection = conns.find(c => Number(c.ConnID || c.NodeID || 0) === Number(connID));
      if (connection?.AgencyID) {
        const rawMyAgencies = localStorage.getItem('MyAgencies');
        if (rawMyAgencies) {
          const myAgencies = JSON.parse(rawMyAgencies);
          const matched = myAgencies.find(agn => String(agn.AgencyID) === String(connection.AgencyID));
          if (matched) {
            apiOptions = {
              userID: Number(matched.UserID),
              forAgencyID: Number(matched.AgencyID)
            };
          }
        }
      }
    } catch (e) {
      console.error('Error fetching connection for agency context in manageRecordAPI:', e);
    }
  }

  try {
    const result = await apiService.sendChange(2, 'action', recPayloadData, apiOptions);
    checkAPIResponse(result);
    return result;
  } catch (error) {
    console.error(`${operation} record API error:`, error);
    throw error;
  }
};
export const getRecordsAPI = async ({ recTypeID, prdType, prdQty, year, month }) => {
  try {
    const payload = [{
      recTypeID,
      prdType,
      prdQty,
      year,
      month
    }];
    
    const result = await apiService.getData(6, 'getRptRecords', payload);
    // Parse the updatePackage to get the actual data
    const updatePackage = JSON.parse(result.updatePackage);
    const data = updatePackage.Table1;

    return data
  } catch (error) {
    console.error('getConnectionDetail API error:', error);
    throw error;
  }
};